// src/platform/firebase/firestore/factory.ts
import { resolveFirebaseRuntime } from '../runtime'
import { createClientFirebase } from '..'
import { FirestoreServiceClient } from './FirestoreServiceClient'
import type { IFirestoreService } from './FirestoreServiceBase'

export async function createFirestoreService(): Promise<IFirestoreService> {
  const rt = resolveFirebaseRuntime(typeof window !== 'undefined' ? 'client' : 'admin')

  if (rt.target === 'client') {
    const { db } = await createClientFirebase()
    return new FirestoreServiceClient(db)
  }

  // For admin environment, use the separate admin factory
  const { createAdminFirestoreService } = await import('./adminFactory')
  return createAdminFirestoreService()
}
